module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "app-content-body fade-in-up content-transition"
  }, [_c('div', {
    staticClass: "hbox hbox-auto-xs hbox-auto-sm"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "r"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h3"
  }, [_vm._v("\n                  GRVs " + _vm._s(_vm.tipoGrvLabel) + " "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(this.pagination.totalItems))])]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Selecione GRV para modificar")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "text-right text-left-xs"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'grv.novo',
        query: {
          tipoGrv: _vm.filtros.tipoGrv
        }
      },
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Nova GRV\n                  ")])], 1)])])]), _vm._v(" "), (_vm.isLoaded) ? _c('div', {
    staticClass: "wrapper-sm"
  }, [_c('div', {
    staticClass: "panel panel-default wrapper-sm",
    attrs: {
      "id": "filters_main"
    }
  }, [_c('div', {
    staticClass: "row m-l-xs m-r-xs",
    attrs: {
      "id": "filters"
    }
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('data-filtro-select', {
    attrs: {
      "label": "Data da Apreensão"
    },
    on: {
      "change": _vm.reloadData
    },
    model: {
      value: (_vm.filtros.data),
      callback: function($$v) {
        _vm.$set(_vm.filtros, "data", $$v)
      },
      expression: "filtros.data"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "title_filter",
    attrs: {
      "for": "filtroCategoria"
    }
  }, [_vm._v("Categoria")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.categoria),
      expression: "filtros.categoria"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "filtroCategoria"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "categoria", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.reloadData]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(" Todos")]), _vm._v(" "), _vm._l((_vm.categoriasFiltered), function(categoria) {
    return _c('option', {
      domProps: {
        "value": categoria.id
      }
    }, [_vm._v(" " + _vm._s(categoria.nome) + "\n                      ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "title_filter",
    attrs: {
      "for": "filtroPatio"
    }
  }, [_vm._v("Pátio")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.patio),
      expression: "filtros.patio"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "filtroPatio"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "patio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.reloadData]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.Patios), function(patio) {
    return _c('option', {
      domProps: {
        "value": patio.id
      }
    }, [_vm._v(" " + _vm._s(patio.nome))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "title_filter",
    attrs: {
      "for": "filtroStatus"
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.status),
      expression: "filtros.status"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "filtroStatus"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.reloadData]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(" Todos")]), _vm._v(" "), _vm._l((_vm.Status), function(status) {
    return _c('option', {
      domProps: {
        "value": status.keyValue
      }
    }, [_vm._v(" " + _vm._s(status.titulo))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "title_filter",
    attrs: {
      "for": "filtroSucata"
    }
  }, [_vm._v("Sucata")]), _vm._v(" "), _c('div', {
    staticClass: "filtro-sucata-switch"
  }, [_c('label', {
    staticClass: "i-switch bg-danger m-r"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.sucata),
      expression: "filtros.sucata"
    }],
    attrs: {
      "type": "checkbox",
      "id": "filtroSucata"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.sucata) ? _vm._i(_vm.filtros.sucata, null) > -1 : (_vm.filtros.sucata)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.filtros.sucata,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "sucata", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "sucata", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "sucata", $$c)
        }
      }, _vm.reloadData]
    }
  }), _vm._v(" "), _c('i')])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "wrapper clearfix"
  }, [_c('div', {
    staticClass: "col-sm-9 m-b-xs"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.busca),
      expression: "filtros.busca"
    }],
    staticClass: "input-sm form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisar"
    },
    domProps: {
      "value": (_vm.filtros.busca)
    },
    on: {
      "keyup": _vm.pesquisar,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "busca", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Buscar")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "overflow-x": "unset"
    }
  }, [_c('table', {
    staticClass: "table table-hover table-striped b-t b-light"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "20px"
    }
  }, [_c('label', {
    staticClass: "i-checks m-b-none"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedAll),
      expression: "checkedAll"
    }],
    attrs: {
      "type": "checkbox",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedAll) ? _vm._i(_vm.checkedAll, null) > -1 : (_vm.checkedAll)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checkedAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkedAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedAll = $$c
        }
      }, function($event) {
        return _vm.checkAll(_vm.arrayData)
      }]
    }
  }), _c('i')])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.sortResults('numero')
      }
    }
  }, [_vm._v("\n                    GRV "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtros.sortBy === 'numero'),
      expression: "filtros.sortBy === 'numero'"
    }],
    class: ("fa fa-caret-" + _vm.iconSortingDirection)
  })]), _vm._v(" "), _c('th', [_vm._v("Placa")]), _vm._v(" "), _c('th', [_vm._v("Chassi")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.sortResults('dataApreensao')
      }
    }
  }, [_vm._v("\n                    Data da Apreensão "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtros.sortBy === 'dataApreensao'),
      expression: "filtros.sortBy === 'dataApreensao'"
    }],
    class: ("fa fa-caret-" + _vm.iconSortingDirection)
  })]), _vm._v(" "), _c('th', [_vm._v("Data Retirada")]), _vm._v(" "), _c('th', [_vm._v("Marca/Modelo")]), _vm._v(" "), _c('th', [_vm._v("Pátio")]), _vm._v(" "), _c('th', [_vm._v("Vaga")]), _vm._v(" "), _c('th', [_vm._v("Nº da Chave")]), _vm._v(" "), _c('th', [_vm._v("No Patio")]), _vm._v(" "), _c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v("Opções")])])]), _vm._v(" "), _c('tbody', [_vm._l(([1, 2, 3]), function(i) {
    return (_vm.isLoading) ? _c('tr', [_c('td', {
      staticClass: "v-middle"
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "20px"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('a', {
      staticClass: "text-cap custom-link"
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1)]), _vm._v(" "), _vm._l((8), function(i) {
      return _c('td', {
        attrs: {
          "role": "button",
          "tabindex": "0"
        }
      }, [_c('u-fake-loader', {
        staticClass: "m-t",
        attrs: {
          "width": "100%"
        }
      })], 1)
    })], 2) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.arrayData), function(data) {
    return _c('tr', {
      style: ('color: ' + _vm.colorSucata(data.sucata))
    }, [_c('td', {
      staticClass: "v-middle"
    }, [_c('label', {
      staticClass: "i-checks m-b-none"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.selected),
        expression: "data.selected"
      }],
      attrs: {
        "type": "checkbox",
        "name": "post[]",
        "tabindex": "0",
        "aria-checked": "false",
        "aria-invalid": "false"
      },
      domProps: {
        "checked": Array.isArray(data.selected) ? _vm._i(data.selected, null) > -1 : (data.selected)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.lazyCheck(data)
        },
        "change": function($event) {
          var $$a = data.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(data, "selected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(data, "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(data, "selected", $$c)
          }
        }
      }
    }), _c('i')])]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(data.id, data.status)
        }
      }
    }, [_c('span', {
      class: {
        'text-danger': data.bloqueadoParaLeilao
      }
    }, [_vm._v(_vm._s(data.numero))]), _vm._v(" "), _c('br'), _vm._v(" "), (data.bloqueadoParaLeilao) ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("(Bloqueada para leilões)")]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(data.id, data.status)
        }
      }
    }, [_c('a', {
      staticClass: "text-cap custom-link"
    }, [_vm._v(_vm._s(data.placa || '----'))])]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(data.id, data.status)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(data.chassi || '----') + "\n                  ")]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(data.id, data.status)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.moment(data.dataApreensao.date).format('DD/MM/YYYY HH:mm')) + "\n                  ")]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(data.id, data.status)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.dataRetirada(data)) + "\n                  ")]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(data.id, data.status)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(data.marca || 'Não informado') + "\n                  ")]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(data.id, data.status)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(data.patio.nome) + "\n                  ")]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(data.id, data.status)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(data.vaga || '-') + "\n                  ")]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(data.id, data.status)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(data.numeroChave || '-') + "\n                  ")]), _vm._v(" "), _c('td', [(_vm.podeMarcarChegou(data)) ? _c('button', {
      staticClass: "btn btn-success btn-sm",
      on: {
        "click": function($event) {
          return _vm.marcarChegou(data)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    }), _vm._v(" Chegou\n                    ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(data.id, data.status)
        }
      }
    }, [_c('span', {
      style: ('color: ' + _vm.StatusTitle(data.status, 'color'))
    }, [_vm._v(_vm._s(_vm.StatusTitle(data.status)))])]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('btn-acoes-grv', {
      attrs: {
        "grv": data,
        "tipoGrv": _vm.filtros.tipoGrv
      },
      on: {
        "openDeclaracaoAcessoVeiculo": _vm.openDeclaracaoAcessoVeiculoModal,
        "emitirDocumentoRetirada": _vm.emitirDocumentoRetirada,
        "excluirGrv": _vm.openExcluirGrvPopup,
        "bloquearParaLeilao": _vm.openBloquearGrvLeilao,
        "verHistoricoDeLeiloes": _vm.openHistoricoLeiloesViewer,
        "verHistoricoDeAlteracoes": _vm.openHistoricoAlteracoesViewer,
        "bloqueadoParaLeilao": _vm.start
      }
    })], 1)])
  }), _vm._v(" "), (_vm.noData) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("Nenhum registro encontrado")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('footer', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 hidden-xs"
  }, [_vm._v("\n                  Mostrar:\n                  "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pagination.limit),
      expression: "pagination.limit"
    }],
    staticClass: "input-sm form-control w-auto inline v-middle",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pagination, "limit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.paginationLimits), function(p) {
    return _c('option', {
      domProps: {
        "value": p
      }
    }, [_vm._v(_vm._s(p))])
  }), 0), _vm._v("\n                  por página\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-center"
  }, [_c('small', {
    staticClass: "text-muted inline m-t-sm m-b-sm"
  }, [_vm._v("\n                    " + _vm._s(_vm.pagination.atualPage) + " / " + _vm._s(_vm.pagination.totalPages) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-right text-center-xs"
  }, [_c('u-pagination', {
    attrs: {
      "atual": _vm.pagination.atualPage,
      "total": _vm.pagination.totalPages
    },
    on: {
      "changePage": _vm.changePage
    }
  })], 1)])])])])])]), _vm._v(" "), (_vm.showDeclaracaoAcessoVeiculoModal) ? _c('popup-viewer', {
    attrs: {
      "title": "Emitir Declaração de Acesso ao Veículo"
    },
    on: {
      "close": _vm.closeDeclaracaoAcessoVeiculoModal
    }
  }, [_c('DeclaracaoAcessoVeiculoForm', {
    ref: "declaracao",
    attrs: {
      "grv": _vm.grvSelecionadaDeclaracao,
      "viewer-mode": ""
    },
    on: {
      "finishSubmit": _vm.closeDeclaracaoAcessoVeiculoModal,
      "cancel": _vm.closeDeclaracaoAcessoVeiculoModal
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showExcluirGrvPopup) ? _c('popup-viewer', {
    attrs: {
      "title": "Excluir GRV"
    },
    on: {
      "close": _vm.closeExcluirGrvPopup
    }
  }, [_c('ExcluirGrvAlerta', {
    attrs: {
      "grvId": _vm.grvSelecionadaParaExcluir
    },
    on: {
      "finishSubmit": function($event) {
        _vm.loadData(_vm.pagination.limit, _vm.pagination.atualPage, _vm.montaFiltros())
      },
      "cancel": _vm.closeExcluirGrvPopup
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showBloquearGrvLeilaoPopup) ? _c('popup-viewer', {
    attrs: {
      "title": "Bloquear GRV para leilão"
    },
    on: {
      "close": _vm.closeBloquearGrvLeilao
    }
  }, [_c('BloquearGrvLeilaoAlerta', {
    attrs: {
      "grvId": _vm.grvSelecionadaParaBloquear
    },
    on: {
      "finishSubmit": function($event) {
        _vm.loadData(_vm.pagination.limit, _vm.pagination.atualPage, _vm.montaFiltros())
      },
      "cancel": _vm.closeBloquearGrvLeilao
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showHistoricoLeiloes) ? _c('popup-viewer', {
    on: {
      "close": _vm.closeHistoricoLeiloesViewer
    }
  }, [_c('HistoricoLeiloesGrv', {
    attrs: {
      "grvId": _vm.grvSelecionadaParaVerificarHistoricoDeLeiloes
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showHistoricoAlteracoes) ? _c('popup-viewer', {
    attrs: {
      "title": "Histórico de Alterações"
    },
    on: {
      "close": _vm.closeHistoricoAlteracoesViewer
    }
  }, [_c('MapaEdicoesGrv', {
    attrs: {
      "grvId": _vm.grvSelecionadaParaVerificarHistoricoDeAlteracoes
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-300cc85d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/grvs/components/ListaGrvs.vue
// module id = 1770
// module chunks = 18